import {locationSelector, uniportalSelector} from 'modules/rootSelectors';
import queryString from 'query-string';
import {createSelector} from 'reselect';
import {loginStates, passwordResetStates, excessiveLoginAttempts} from './constants';

export const authenticationSelector = createSelector(uniportalSelector, uniportal => uniportal.authentication || {});

export const loginStateSelector = createSelector(
    authenticationSelector,
    auth => auth.loginState || loginStates.ENTER_USERNAME
);
export const isLoggedInSelector = createSelector(loginStateSelector, state => state === loginStates.LOGGED_IN);
export const excessiveLoginAttemptsSelector = createSelector(authenticationSelector, auth => auth.failedLoginAttempts >= excessiveLoginAttempts);

export const resetStateSelector = createSelector(
    authenticationSelector,
    auth => auth.passwordResetState || passwordResetStates.ENTER_EMAIL
);

export const invalidResetCodeSelector = createSelector(
    authenticationSelector,
    auth => auth.invalidResetCode || false
);

export const authRedirectSelector = createSelector(
    locationSelector,
    location => {
        if (location.pathname) {
            // parse path for auth method
            const [method, login] = location.pathname.split('/').reverse();
            console.log(method, login);
            if (login == 'login') {
                if (location.search) {
                    const params = queryString.parse(location.search);
                    return {
                        method,
                        code: params.code || null,
                    };
                }
            }
        }
        return null;
    }
);